<template>
  <div v-if="shownTasks.length > 0">
    <div class="ts-comp--multiselect-item" @click="expanded = !expanded">
      <div>
        <label style="color:#022c81;">{{ group.talent }} </label>
      </div>
    </div>

    <div class="ts-comp--multiselect-item child" v-if="expanded">
      <div
        class="option"
        v-for="(item, index) in group.skillsAssociated.filter(sk => !selectedItems.includes(sk))"
        :key="index"
      >
          <label @click="$emit('skillSelected', item)"><div class="ts-checkbox" > </div>{{ item }} </label>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    group: {
      type: Object,
      required: true,
      validator: v =>
        Object.keys(v).includes("talent") &&
        Object.keys(v).includes("skillsAssociated")
    },
    selectedItems: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      expanded: true
    };
  },
  computed: {
    shownTasks() {
      return this.group.skillsAssociated.filter(sk => !this.selectedItems.includes(sk))
    }
  },
};
</script>
<style lang="scss">
.header {
  font-size: 22px;
  color: gray;
  &:hover {
    cursor: pointer;
  }
}
</style>
